import React, { Component } from "react";
import Display from "./Display";
import "./style.css";

class App extends Component {
  render() {
    return (
      <>
        <div className="App">
          <Display />
        </div>
      </>
    );
  }
}

export default App;
